"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StorytellingBanner() {
  return <section id="storytellingbanner" className="relative overflow-hidden bg-zinc-950 py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/workspace_dark_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/workspace_dark_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/workspace_dark_bg.png-wvc-sizes" alt="Dark workspace background" className="h-full w-full object-cover object-center opacity-40" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/90 to-zinc-950/80 mix-blend-multiply" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center overflow-hidden opacity-[0.03]">
        <span className="font-default text-[12vw] font-bold whitespace-nowrap text-white uppercase tracking-tighter">
          Welcome in Lionia Project
        </span>
      </div>

      <div className="container relative z-10 mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          
          {}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: "easeOut"
        }} className="border-white/10 pb-8 lg:col-span-8 lg:border-r lg:border-b-0 lg:pb-0 lg:pr-12 border-b">
            <h2 className="font-default text-4xl font-bold leading-[1.1] tracking-tight text-white md:text-5xl lg:text-6xl">
              Hai una storia da raccontare?{" "}
              <span className="text-primary">Scrivimi.</span>{" "}
              <br className="hidden md:block" />
              Potresti entrare nel progetto.
            </h2>
          </motion.div>

          {}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: "easeOut",
          delay: 0.2
        }} className="flex flex-col justify-center gap-4 lg:col-span-4 lg:pl-6">
            <Button asChild size="lg" className="h-14 w-full text-lg font-semibold shadow-lg transition-transform hover:scale-[1.02]">
              <Link to="#">
                Scrivimi
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-14 w-full border-white/20 bg-transparent text-lg font-medium text-white shadow-md backdrop-blur-sm transition-all hover:bg-white/10 hover:text-white">
              <Link to="#">
                Vuoi essere ospite? Scrivimi
              </Link>
            </Button>
          </motion.div>

        </div>
      </div>
    </section>;
}